<template>
    <div>
        <div class="hr-header" style="margin-top: 20px"><p>3D View</p></div>
        <table class="bm-table">
            <tr>
                <td class="bm-table-name">Type</td>
                <td class="bm-table-ope">
                    <el-select v-model="view_val" placeholder="">
                        <el-option
                                v-for="item in view_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Background</td>
                <td class="bm-table-ope">
                    <el-select v-model="view_val" placeholder="">
                        <el-option
                                v-for="item in view_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ThreeView",
        data() {
            return {
                view_options: [
                    {
                        value: "Cartoon",
                        label: "Cartoon",
                    },
                    {
                        value: "Ribbon",
                        label: "Ribbon",
                    },
                    {
                        value: "Rope",
                        label: "Rope",
                    },
                    {
                        value: "Trace",
                        label: "Trace",
                    },
                    {
                        value: "Tube",
                        label: "Tube",
                    },
                    {
                        value: "Line",
                        label: "Line",
                    },
                    {
                        value: "Backbone",
                        label: "Backbone",
                    },
                    {
                        value: "Ball+Stick",
                        label: "Ball+Stick",
                    },
                    {
                        value: "Hyperball",
                        label: "Hyperball",
                    },
                    {
                        value: "Licorice",
                        label: "Licorice",
                    },
                    {
                        value: "Point",
                        label: "Point",
                    },
                    {
                        value: "Spacefill",
                        label: "Spacefill",
                    },
                    {
                        value: "Surface",
                        label: "Surface",
                    },
                ],
                view_val: "Cartoon",

                color: '#409EFF',
                selectedRange: {},
                predefineColors: [
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#1e90ff',
                    '#c71585',
                ]
            }
        }
    }
</script>

<style scoped>

</style>
